<!--
  @Breadcrumbs  Navigation bar at the top of a module, or of the play screen for the master (inside its header).
  Shows a back button, the breadcrumbs, optional buttons, and the help button in the top right corner
  (page actions are in the Sidebar). The bar is placed in the grid area `area` of the module grid.
  The `end` snippet is rendered right of the help button (e.g. the timer in an encounter).
-->

<script>
		import HelpButton from "./HelpButton.svelte";

		/** crumbs: [{label, onclick?}] (crumbs without onclick are shown as plain text) **/
		let {area = 'mnav', back = false, crumbs = [], current = "", children, end, ...rest} = $props()
</script>


<nav class="breadcrumbs" style:grid-area={area} {...rest}>
	{#if back}
		<button class="back button-circle icon-arrow-left" title="zurück" onclick={() => history.back()}></button>
	{/if}
	<div class="crumbs">
		{#each crumbs as crumb}
			{#if crumb.onclick}
				<button class="crumb" onclick={crumb.onclick}>{crumb.label}</button>
			{:else}
				<span class="crumb plain">{crumb.label}</span>
			{/if}
			<span class="sep">/</span>
		{/each}
		<h2>{current}</h2>
	</div>
	{@render children?.()}
	<span class="spacer"></span>
	<HelpButton/>
	{#if end}
		<div class="end">{@render end()}</div>
	{/if}
</nav>


<style lang="sass">
	@use "../colors" as colors

	.breadcrumbs
		position: relative
		z-index: 9
		min-width: 0
		min-height: 51px
		box-sizing: border-box
		background-color: colors.$primary-040-black
		padding: 0 8px 0 16px
		display: flex
		align-items: center
		gap: 16px

		.back
			flex: none

	.crumbs
		flex: 0 1 auto
		display: flex
		align-items: baseline
		gap: 10px
		min-width: 0
		white-space: nowrap
		overflow: hidden

		h2
			margin: 0
			font-size: 20px
			overflow: hidden
			text-overflow: ellipsis

	.crumb
		flex: none
		padding: 0
		border: 0
		background: none
		font-size: 20px
		color: colors.$grey-85

		&:not(.plain)
			cursor: pointer

			&:hover
				color: colors.$white
				text-decoration: underline colors.$primary-100

	.sep
		color: colors.$grey-50

	.spacer
		flex: 1

	.end
		align-self: stretch
		display: flex
		margin-right: -8px
</style>
